import bcryptjs from "bcryptjs";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";
import { db } from "../config/firebaseConfig";
import { signTransaction } from "./MainComponent";
const CreateTranscation = ({ user, userData, roomId }) => {
  const [senderprivateKey, setsenderprivateKey] = useState("");
  const [transactionReceiverPublicKey, setTransactionReceiverPublicKey] =
    useState("");
  const [transactionAmount, setTransactionAmount] = useState(0);
  const [isTransactionSigned, setIsTransactionSigned] = useState(false);
  let [signature, setSignature] = useState(null);
  const [transactionHash, setTransactionHash] = useState(null);

  // Check for prefilled values from Participants page
  useEffect(() => {
    const prefilledReceiver = localStorage.getItem("prefilledReceiver");
    const prefilledAmount = localStorage.getItem("prefilledAmount");

    if (prefilledReceiver) {
      setTransactionReceiverPublicKey(prefilledReceiver);
      localStorage.removeItem("prefilledReceiver");
    }

    if (prefilledAmount) {
      setTransactionAmount(parseFloat(prefilledAmount));
      localStorage.removeItem("prefilledAmount");
    }
  }, []);

  const handleGenerateSignature = async (receiverPublicKey, amount) => {
    if (!receiverPublicKey || amount <= 0) {
      toast.error("Invalid receiver public key or amount");
      return;
    }

    try {
      await generateSignature(receiverPublicKey, amount);
    } catch (error) {
      console.error("Error generating signature:", error.message);
      toast.error("Error generating signature");
    }
  };

  const handleCreateTransaction = async (receiverPublicKey, amount) => {
    if (!isTransactionSigned) {
      toast.error("Please sign the transaction first");
      return;
    }

    if (!receiverPublicKey || amount <= 0) {
      toast.error("Invalid receiver public key or amount");
      return;
    }

    try {
      await createTransaction(receiverPublicKey, amount);
    } catch (error) {
      toast.error("Error creating transaction");
    }
  };

  const generateSignature = async (receiverPublicKey, amount) => {
    // Generate transaction data
    const transactionData = {
      sender: userData.publicKey,
      senderEmail: user.email,
      receiver: receiverPublicKey,
      nonce: Math.floor(Math.random() * (10 - 1)) + 1,
      amount: Number(amount),
      status: "Verify", // Initial status of the transaction
    };

    if (!senderprivateKey) {
      toast.error("Private key is required to sign the transaction");
      return;
    }
    let data = await signTransaction(transactionData, senderprivateKey);
    setSignature(data);
    if (!data) {
      toast.error("Failed to generate signature");
      return;
    }
    toast.success(
      "Signature generated successfully using RSA, now create transaction",
    );
    setIsTransactionSigned(true);
  };

  const createTransaction = async (receiverPublicKey, amount) => {
    if (!signature) {
      toast.error("Signature is missing");
      return;
    }

    // Add signature to transaction data
    const transactionData = {
      sender: userData.publicKey,
      senderEmail: user.email,
      receiver: receiverPublicKey,
      nonce: Math.floor(Math.random() * (10 - 1)) + 1,
      amount: Number(amount),
      status: "Verify", // Initial status of the transaction
      signature: signature,
    };

    // Create transaction in Firestore
    try {
      const hash = bcryptjs.hashSync(JSON.stringify(transactionData));
      await addDoc(collection(db, "rooms", roomId, "transactions"), {
        ...transactionData,
        hash,
        timestamp: serverTimestamp(),
      });
      toast.success(`Transaction sent successfully with Hash : ${hash}`);
      setsenderprivateKey("");
      setTransactionReceiverPublicKey("");
      setTransactionAmount("");
      setIsTransactionSigned(false);
      setTransactionHash(hash);
    } catch (error) {
      console.error("Error making transaction", error.message);
      toast.error("Error making transaction", error.message);
    }
  };
  // read `to` query param to prefill the receiver field when navigated from leaderboard
  const location = useLocation();
  useEffect(() => {
    try {
      const params = new URLSearchParams(location.search);
      const to = params.get("to");
      if (to) {
        setTransactionReceiverPublicKey(decodeURIComponent(to));
        setIsTransactionSigned(false);
      }
    } catch (err) {
      // ignore
    }
  }, [location.search]);
  return (
    <div className="space-y-4">
      <div>
        <label className="text-white/60 text-sm mb-2 block">
          Receiver Public Key
        </label>
        <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
          <input
            type="text"
            className="flex-1 bg-transparent text-white text-sm outline-none"
            placeholder="Enter receiver public key"
            value={transactionReceiverPublicKey}
            onChange={(e) => {
              setTransactionReceiverPublicKey(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
          <button className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>

      <div>
        <label className="text-white/60 text-sm mb-2 block">
          Your Private Key
        </label>
        <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
          <input
            type="password"
            className="flex-1 bg-transparent text-white text-sm outline-none"
            placeholder="Enter your private key"
            value={senderprivateKey}
            onChange={(e) => {
              setsenderprivateKey(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
          <button className="w-8 h-8 flex items-center justify-center bg-[#7C5CFC] hover:bg-[#6B4BEB] rounded transition">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="white"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </button>
        </div>
      </div>

      <div>
        <label className="text-white/60 text-sm mb-2 block">Amount</label>
        <div className="flex items-center gap-2 bg-[#1B1E3E]/60 border border-white/10 rounded-lg px-4 py-3">
          <input
            type="number"
            className="flex-1 bg-transparent text-white text-sm outline-none"
            placeholder="Enter amount"
            value={transactionAmount}
            onChange={(e) => {
              setTransactionAmount(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
        </div>
      </div>

      <div className="mt-6 space-y-3">
        <button
          onClick={() =>
            handleGenerateSignature(
              transactionReceiverPublicKey,
              transactionAmount,
            )
          }
          type="button"
          disabled={
            !transactionReceiverPublicKey ||
            !senderprivateKey ||
            !transactionAmount ||
            Number(transactionAmount) <= 0 ||
            isTransactionSigned
          }
          className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:from-[#5B3FE8] hover:to-[#4A2FD7] rounded-lg font-semibold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-[#6C4FFF] disabled:hover:to-[#5B3FE8]"
        >
          Sign transaction
        </button>
        <button
          onClick={() =>
            handleCreateTransaction(
              transactionReceiverPublicKey,
              transactionAmount,
            )
          }
          type="button"
          disabled={
            !isTransactionSigned ||
            !transactionReceiverPublicKey ||
            !senderprivateKey ||
            !transactionAmount ||
            Number(transactionAmount) <= 0
          }
          className="w-full px-6 py-3 bg-gradient-to-r from-[#6C4FFF] to-[#5B3FE8] hover:from-[#5B3FE8] hover:to-[#4A2FD7] rounded-lg font-semibold text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:from-[#6C4FFF] disabled:hover:to-[#5B3FE8]"
        >
          Send Transaction To Mempool
        </button>
      </div>

      {transactionHash && (
        <div className="mt-4 p-4 bg-green-500/10 border border-green-500/30 rounded-lg">
          <p className="text-green-400 text-sm font-semibold break-all">
            Transaction hash: {transactionHash}
          </p>
        </div>
      )}
    </div>
  );
};

export default CreateTranscation;
